//
//
//
//

export default {
    name: "login",
    created(){
        // console.log(this.$route)
        let redirect = encodeURIComponent(this.$route.query.redirect)
        let serverUrl = this.$route.query.serverUrl
        let questUrl = serverUrl+'?r='+redirect
        location.href = questUrl
    }
}



// WEBPACK FOOTER //
// ./src/components/Login.vue